// extracted by mini-css-extract-plugin
export default {"title":"S5XNb5bCSDPS69zL1FHR"};